import type { JSX } from 'react';

import { Layout } from '../layout';

export function Open(): JSX.Element {
	return <Layout />;
}
